export default __webpack_public_path__ + "static/media/625.50ee318b.gif";